import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const textToUnsafeHTML = (text: string) => unsafeHTML(text.replace(/\n/g, '<br /><br />'));
